import { addStyles } from 'ethcss'
import { item, IStyles, grid, colors, mediaCSS } from 'theme'
import { defaultThemeStyles } from './Steps-theme'

export const stepsStyles: IStyles = {
    Steps: {
        ...grid.row,
        gap: 10,
        [mediaCSS.tab]: {
            ...grid.justify,
        },
    },
    Steps__content: {
        ...grid.space,
        ...grid.rowCenter,
        ...grid.p_md,
        ...item.pointer,
        textDecoration: 'none',
        borderRadius: '7px',
        // color: `var(--var-module-ui-component-steps-style-textMain, ${defaultThemeStyles.textMain})`,
        color: `var(--var-module-ui-component-steps-style-textMain, ${defaultThemeStyles.textDefault})`,
        //border: `1px solid var(--var-module-ui-component-steps-style-hoverBackground, ${defaultThemeStyles.hoverBackground})`,
        // marginRight: '10px',
        textAlign: 'center',
        '&:hover': {
            backgroundColor: `var(--var-module-ui-component-steps-style-hoverBackground, ${defaultThemeStyles.hoverBackground})`,
        },
        '&:last-child': {
            marginRight: 0,
        },
        gap: 16,
        [mediaCSS.tab]: {
            maxWidth: '48%',
            ...grid.col,
            gap: 4,
        },
    },
    Steps__content_default_activated: {
        backgroundColor: `var(--var-module-ui-component-steps-style-activeBackground, ${defaultThemeStyles.activeBackground})`,
    },
    Steps__content_default_disabled: {
        backgroundColor: `var(--var-module-ui-component-steps-style-background, ${defaultThemeStyles.background})`,
    },
    Steps__content_inverse_activated: {
        backgroundColor: `var(--var-module-ui-component-steps-style-inverseTabActive, ${defaultThemeStyles.inverseTabActive})`,
    },
    Steps__content_inverse_disabled: {
        backgroundColor: `var(--var-module-ui-component-steps-style-textMain, ${defaultThemeStyles.textMain})`,
    },
    Steps__content_accent_activated: {
        color: colors.white,
        backgroundColor: `var(--var-module-ui-component-steps-style-activeAccentBackground, ${defaultThemeStyles.activeBackground})`,
    },
    Steps__content_accent_disabled: {
        backgroundColor: `var(--var-module-ui-component-steps-style-background, ${defaultThemeStyles.background})`,
    },
}

addStyles(stepsStyles)
